document.addEventListener('DOMContentLoaded', () => {
  const popUp = document.querySelector('.custom_pop_up_wrapper');
  const closePopUp = document.querySelector('.custom_pop_up_close_btn');

  if (!popUp) return;

  const alwaysVisible = popUp.dataset.alwaysVisible === 'true';

  // Si always_visible está activo, mostrar y no cerrar nunca
  if (alwaysVisible) {
    popUp.classList.add('active');
    return;
  }

  // Clave única por página (ruta)
  const pageKey = `popupShown:${window.location.pathname}`;
  const alreadyShownOnThisPage = sessionStorage.getItem(pageKey) === 'true';

  function markAsShown() {
    sessionStorage.setItem(pageKey, 'true');
  }

  function hidePopup() {
    popUp.classList.remove('active');
  }

  function showPopupOnce() {
    if (alreadyShownOnThisPage) return;

    popUp.classList.add('active');
    markAsShown();

    setTimeout(() => {
      hidePopup();
    }, 5000);
  }

  if (closePopUp) {
    closePopUp.addEventListener('click', () => {
      hidePopup();
      markAsShown();
    });
  }

  // Mostrar al entrar a la página (una sola vez por página)
  showPopupOnce();
});